module.exports = { id: "award", url: "/build/app/img/symbols.svg#award", viewBox: "", toString: function() { return this.url; } };